import { useEffect } from 'react';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

import useGlobalStore from 'hooks/useGlobalStore';
import { trackEvent } from 'utils/analyticsUtils';

export const FLAG_NAME = 'reorder-experience-buy-it-again';

/**
 * Split treatment values for the "Reorder Experience: Buy It Again" experiment.
 */
export const SplitTreatment = Object.freeze({
    BANNER: 'banner',
    CAROUSEL: 'carousel',
    OFF: 'off',
});

/**
 * Returns the Split treatment for the "Reorder Experience: Buy It Again" feature flag.
 *
 * @returns {SplitTreatment} The user's Split treatment.
 */
export function useBuyItAgainFeatureFlag() {
    const { isMisfitsTheme } = useGlobalStore();
    const {
        isReady: splitIsReady,
        isTimedout: splitTimedout,
        treatments: splitTreatments,
    } = useSplitTreatments({ names: [FLAG_NAME] });

    const splitTreatment = splitTreatments?.[FLAG_NAME]?.treatment ?? {};

    useEffect(() => {
        if (splitIsReady && !splitTimedout) {
            trackEvent('split experiment assign', {
                experiment: FLAG_NAME,
                variation: splitTreatment,
                brand: isMisfitsTheme ? 'misfits_market' : 'imperfect_foods',
            });
        }
    }, [splitIsReady, splitTimedout]);

    return {
        isReady: splitIsReady,
        treatment: splitTreatment,
    };
}
